export default __webpack_public_path__ + "static/media/cover.4f8455a4.png";